import React from "react";

const CaptureScheme = () => {
    return <div>CaptureScheme</div>;
};

export default CaptureScheme;